const changeProfilePictureStr = {
  toastr: 'Foto de perfil alterada',
  toastr1: 'Foto de perfil alterada com sucesso'
};

export default changeProfilePictureStr;
